'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _changePasswordConstants = require('./changePasswordConstants');

var CHANGE_PASSWORD_ACTION_TYPES = _interopRequireWildcard(_changePasswordConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Initial state
// Lib
var initialState = Immutable.Map({
    isLoading: true,
    isError: false,
    isExpired: false,
    passwordUpdated: false,
    email: '',
    error: null,
    code: null
});

// Constants

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_FAILED:
            return state.set('isLoading', false).set('isError', true).set('error', action.error);
        case CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_CODE_EXPIRED:
            return state.set('isLoading', false).set('isExpired', true);
        case CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGE_INITIALISED:
            return state.set('isLoading', false).set('email', action.email).set('code', action.code);
        case CHANGE_PASSWORD_ACTION_TYPES.PASSWORD_CHANGED:
            return state.set('passwordUpdated', true);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/changePassword/changePasswordModalReducer.js
// module id = 1676
// module chunks = 0